


import axiosInstance from '../../services/axiosMiddleware';

export async function MarkComplete(pranyammaData) {
  try {
    const response = await axiosInstance.post('pranayamma/mark-complete', pranyammaData);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
